import { React } from "react";
import Facebook from "../../../Assets/Svg/facebook2.svg";
import Instagram from "../../../Assets/Svg/instagram2.svg";
import Telegram from "../../../Assets/Svg/Telegram2.svg";
import Whatsapp from "../../../Assets/Svg/Whatsapp.svg";
import Skype from "../../../Assets/Svg/skype.svg";
import Tiktok from "../../../Assets/Svg/tiktok.svg";
import { useNavigate } from "react-router-dom";
import EditFormInput from "./edit-form-input";
import EditCard from "./edit-card";
import EditFormSelect from "./edit-form-select";
import Sidebar from "./Sidebar";

const EditForm = ({
  editedProfile,
  handleInputChange,
  isEditing,
  countries,
}) => {
  const countryOptions = countries.map((country) => ({
    value: country.id, // or use country.id based on your requirement
    label: country.name,
  }));
  console.log(editedProfile);
  return (
    <>
      <div className={'profile-container'}>
        {/*<div className={"show-details"}>*/}
        {/*  <Sidebar isOpen={true}/>*/}
        {/*</div>*/}
        <div className={"edit-form"}>
          <EditFormInput
              showInProfile={true}
              readOnly={false}
              type={"text"}
              isEditing={isEditing}
              label={"User Name"}
              editedProfile={editedProfile}
              handleInputChange={handleInputChange}
              inputName={"name"}
              inputValue={editedProfile.name}
          />
          <EditFormInput
              showInProfile={true}
              readOnly={false}
              type={"text"}
              isEditing={isEditing}
              label={"About"}
              editedProfile={editedProfile}
              handleInputChange={handleInputChange}
              inputName={"about"}
              inputValue={editedProfile.about}
          />
          <EditFormInput
              showInProfile={true}
              readOnly={true}
              type={"text"}
              isEditing={isEditing}
              label={"Email"}
              editedProfile={editedProfile}
              handleInputChange={handleInputChange}
              inputName={"email"}
              inputValue={editedProfile.email}
          />
          <EditFormSelect
              isEditing={isEditing}
              label={"Gender"}
              editedProfile={editedProfile}
              handleInputChange={handleInputChange}
              inputName={"sex"}
              inputValue={editedProfile.sex}
              options={[
                { value: "male", label: "Male" },
                { value: "female", label: "Female" },
                { value: "other", label: "Other" },
              ]}
          />
          <EditFormSelect
              isEditing={isEditing}
              label={"Country"}
              editedProfile={editedProfile}
              handleInputChange={handleInputChange}
              inputName={"country"}
              inputValue={editedProfile.country}
              options={countryOptions}
          />
          <div className={"social-icon-div"}>
            <EditFormInput
                showInProfile={false}
                readOnly={false}
                type={"text"}
                isEditing={isEditing}
                label={"Facebook"}
                icon={Facebook}
                editedProfile={editedProfile}
                handleInputChange={handleInputChange}
                inputName={"facebook"}
                inputValue={editedProfile.facebook}
            />
            <EditFormInput
                showInProfile={false}
                readOnly={false}
                type={"text"}
                isEditing={isEditing}
                label={"Instagram"}
                icon={Instagram}
                editedProfile={editedProfile}
                handleInputChange={handleInputChange}
                inputName={"instagram"}
                inputValue={editedProfile.instagram}
            />
            <EditFormInput
                showInProfile={false}
                readOnly={false}
                type={"text"}
                isEditing={isEditing}
                label={"Telegram"}
                icon={Telegram}
                editedProfile={editedProfile}
                handleInputChange={handleInputChange}
                inputName={"telegram"}
                inputValue={editedProfile.telegram}
            />
            <EditFormInput
                showInProfile={false}
                readOnly={false}
                type={"text"}
                isEditing={isEditing}
                label={"Whatsapp"}
                icon={Whatsapp}
                editedProfile={editedProfile}
                handleInputChange={handleInputChange}
                inputName={"whatsapp"}
                inputValue={editedProfile.whatsapp}
            />
            <EditFormInput
                showInProfile={false}
                readOnly={false}
                type={"text"}
                isEditing={isEditing}
                label={"Skype"}
                icon={Skype}
                editedProfile={editedProfile}
                handleInputChange={handleInputChange}
                inputName={"skype"}
                inputValue={editedProfile.skype}
            />
            <EditFormInput
                showInProfile={false}
                readOnly={false}
                type={"text"}
                isEditing={isEditing}
                label={"Tiktok"}
                icon={Tiktok}
                editedProfile={editedProfile}
                handleInputChange={handleInputChange}
                inputName={"tiktok"}
                inputValue={editedProfile.tiktok}
            />
          </div>
        </div>



      </div>

    </>
  );
};

export default EditForm;
